<template>
    <b-modal v-model="ShowModal" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop="true"
        no-close-on-esc="true" centered hide-header hide-footer>
        <template v-slot:default>
            <p>
                Debit Card payment limit is upto RM5,000.00.
            </p>
            <p>
              Please choose another payment option for this amount.
            </p>
            <br />
            <div class="modal-button-wrapper">
                <b-button block variant="danger" @click="handleOk">OK</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
    import CommonService from "../services/common";
    export default {
        name: "Diable5KDebitCardDialog",
        props: ["ShowModal"],
        methods: {
            handleOk: function (evt) {
                this.ShowModal = false;
                this.$emit('okclicked', this.ShowModal);
                evt.preventDefault();
            }
        }
    };
</script>